<template>
  <div v-if="addressbookStubs">
    <p>
      <v-btn :to="documentEntityTypeLink">
        <v-icon>chevron_left</v-icon>Change entity type
      </v-btn>
    </p>
    <h1>Choose entities</h1>
    <FileWorking :file="file" />
    <v-alert :value="true" type="info">Select the entities you wish to address with this document</v-alert>
    <v-checkbox
      v-for="addressbookStub in addressbookStubs"
      :key="addressbookStub.addressbookId"
      v-model="addressbookStub.selected"
      :label="addressbookStub.entity.nameFormatted"
    />
    <v-btn @click="navigate">
      Select
      <v-icon>chevron_right</v-icon>
    </v-btn>
    <v-alert :value="feedback" type="error">{{feedback}}</v-alert>
  </div>
</template>

<script>
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "DocumentEntity",
  metaInfo() {
    return {
      title: "Document entity",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    FileWorking
  },
  computed: {
    documentEntityTypeLink() {
      return {
        name: "documentEntityType",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId
        }
      };
    }
  },
  data() {
    return {
      file: null,
      addressbook: null,
      addressbookStubs: null,
      feedback: null
    };
  },
  methods: {
    fetchFile() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.params.objectId}`)
        .then(response => {
          // console.log(response.data);
          this.file = response.data;
        });
    },
    fetchAddressbook() {
      nbmlaw
        .get(
          `/cors/admin/file/files/${this.$route.params.objectId}/addressbook`
        )
        .then(response => {
          // console.log(response.data);
          this.addressbook = response.data;
        });
    },
    navigate() {
      // selected stubs
      const selected = this.addressbookStubs.filter(addressbookStub => {
        return addressbookStub.selected;
      });
      if (selected.length == 0) {
        //check something is selected
        this.feedback = "You need to select at least one";
        return;
      }
      //join entity ids with dot
      const entities = selected
        .map(addressbookStub => {
          return addressbookStub.entity.entityId;
        })
        .join(".");
      //redirectUri
      this.redirect(entities);
    },
    redirect(entities) {
      this.$router.push({
        name: "documentTemplate",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId,
          entityTypeId: this.$route.params.entityTypeId,
          entities
        }
      });
    }
  },
  watch: {
    addressbook() {
      if (this.addressbook) {
        // console.log(this.addressbook);
        const addressbookStubs = this.addressbook.addressbookTypes
          .filter(
            addressbookType =>
              addressbookType.type.entityTypeId ==
              this.$route.params.entityTypeId
          )
          .map(addressbookType => {
            return addressbookType.addressbookStubs.map(addressbookStub => {
              return {
                addressbookId: addressbookStub.addressbookId,
                entity: addressbookStub.entity,
                selected: true
              };
            });
          });
        // console.log(this.addressbookStubs);
        if (addressbookStubs.length == 1) {
          this.feedback = null;
          this.addressbookStubs = addressbookStubs[0];
          if (this.addressbookStubs.length == 1) {
            this.redirect(this.addressbookStubs[0].entity.entityId);
          } else if (this.addressbookStubs.length == 0) {
            this.$router.push({
              name: "file",
              params: {
                id: this.$route.params.objectId
              }
            });
          }
        }
      } else {
        this.addressbookStubs = null;
      }
    }
  },
  created() {
    this.fetchAddressbook();
    this.fetchFile({
      token: this.$keycloak.token,
      id: this.$route.params.objectId
    });
  }
};
</script>

<style>
</style>
